// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/home/gp2mv3/Programmation/remindme/landing/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-js": () => import("/home/gp2mv3/Programmation/remindme/landing/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-howto-js": () => import("/home/gp2mv3/Programmation/remindme/landing/src/pages/howto.js" /* webpackChunkName: "component---src-pages-howto-js" */),
  "component---src-pages-twitter-js": () => import("/home/gp2mv3/Programmation/remindme/landing/src/pages/twitter.js" /* webpackChunkName: "component---src-pages-twitter-js" */)
}

exports.data = () => import("/home/gp2mv3/Programmation/remindme/landing/.cache/data.json")

